import React from 'react';
import {
    Box,
    Container,
    Typography,
    Button,
    Paper,
    Alert,
} from '@mui/material';
import {
    Lock as LockIcon,
    Home as HomeIcon,
    ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const Unauthorized = () => {
    const navigate = useNavigate();
    const userType = authService.getUserType();

    const handleGoHome = () => {
        const dashboardPaths = {
            employee: '/employee/dashboard',
            franchise: '/franchise/dashboard',
            customer: '/customer/dashboard'
        };
        navigate(dashboardPaths[userType] || '/login');
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container component="main" maxWidth="md">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minHeight: '60vh',
                    justifyContent: 'center',
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        padding: 6,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        textAlign: 'center',
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: 'error.main',
                            borderRadius: '50%',
                            padding: 3,
                            marginBottom: 3,
                        }}
                    >
                        <LockIcon sx={{ color: 'white', fontSize: 48 }} />
                    </Box>

                    <Typography variant="h3" component="h1" gutterBottom color="error">
                        403
                    </Typography>

                    <Typography variant="h5" component="h2" gutterBottom>
                        Access Denied
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500 }}>
                        You don't have permission to access this page. This could be because:
                    </Typography>

                    <Alert severity="warning" sx={{ mb: 4, width: '100%', textAlign: 'left' }}>
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                            <li>Your role doesn't have the required permissions</li>
                            <li>The page requires specific access rights</li>
                            <li>Your session may have expired</li>
                        </ul>
                    </Alert>

                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            startIcon={<HomeIcon />}
                            onClick={handleGoHome}
                            size="large"
                        >
                            Go to Dashboard
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<ArrowBackIcon />}
                            onClick={handleGoBack}
                            size="large"
                        >
                            Go Back
                        </Button>
                    </Box>

                    <Typography variant="caption" color="text.secondary" sx={{ mt: 4 }}>
                        If you believe this is an error, please contact your administrator.
                    </Typography>
                </Paper>
            </Box>
        </Container>
    );
};

export default Unauthorized; 